import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @author PKr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { SegmentationModel } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { SegmentationModelLayer } from '../../transportLayers/promo-settings/SegmentationModelLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/** Persistent store for WindowType */

export var SegmentationModelStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(SegmentationModelStore, _BaseStore);

  function SegmentationModelStore() {
    var _this;

    _classCallCheck(this, SegmentationModelStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SegmentationModelStore).apply(this, arguments));
    _this.name = StoreName.SegmentationModel;
    _this.segmentationLayer = new SegmentationModelLayer();
    return _this;
  }
  /**
   * Gets segmentation model
   * @returns a promise with segmentation model
   */


  _createClass(SegmentationModelStore, [{
    key: "getSegmentation",
    value: function getSegmentation() {
      var _this2 = this;

      return this.segmentationLayer.getSegmentation().then(function (segmentationModel) {
        runInAction(function () {
          _this2.segmentationModel = segmentationModel;
        });
        return segmentationModel;
      });
    }
  }, {
    key: "updateSegmentation",

    /**
     * Updates segmentation model
     * @param segmentationModel - new segmentation model data
     */
    value: function updateSegmentation(segmentationModel) {
      var _this3 = this;

      return this.segmentationLayer.updateSegmentation(segmentationModel).then(function (type) {
        runInAction(function () {
          _this3.segmentationModel = segmentationModel;
        });
        return segmentationModel;
      });
    }
  }]);

  return SegmentationModelStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", SegmentationModel)], SegmentationModelStore.prototype, "segmentationModel", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], SegmentationModelStore.prototype, "getSegmentation", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [SegmentationModel]), __metadata("design:returntype", Promise)], SegmentationModelStore.prototype, "updateSegmentation", null);